import templateUrl from './vet-form.html';

export default {
  templateUrl,
  bindings: {
    adverseEvent: '<',
    states: '<',
    locked: '<'
  },
  controller: class VetFormComponent {
    constructor() {
      'ngInject';
    }

    hasValidContact(adverseEvent) {
      const validOwner = (adverseEvent.OwnerPerson
        && adverseEvent.OwnerPerson.FirstName
        && adverseEvent.OwnerPerson.LastName
        && adverseEvent.OwnerPerson.HomePhone);

      return validOwner;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/vet-form/vet-form.component.js